import { CSSProperties } from 'react';
import styled from '@emotion/styled';

type Props = {
  flexDirection?: CSSProperties['flexDirection'];
  flex?: CSSProperties['flex'];
  alignItems?: CSSProperties['alignItems'];
  alignSelf?: CSSProperties['alignSelf'];
  justifyContent?: CSSProperties['justifyContent'];
  gap?: CSSProperties['gap'];
};

export default styled.div<Props>((props) => ({
  display: 'flex',
  flexDirection: props.flexDirection ?? 'column',
  alignItems: props.alignItems ?? 'stretch',
  flex: props.flex,
  alignSelf: props.alignSelf,
  justifyContent: props.justifyContent,
  gap: props.gap,
}));
